<div class="skeleton-container">
  <div class="layout-sidebar green-skeleton">
    <div class="company_content">
      <div class="logo"></div>
      <div class="comp-title">MedEase</div>
    </div>
  </div>
  <div class="layout-main-content">
    <div class="app-header skeleton"></div>
    <div class="page-content">
      <div class="app-dashboard">
        <div class="card overview skeleton"></div>
        <div class="menu-and-item">
          <div class="sub-menu skeleton"></div>
          <div class="card item skeleton"></div>
        </div>
      </div>
    </div>
  </div>
</div>
